import HtmlToReact from 'html-to-react';

import { addClosingTags, processingInstructions } from './templateHelper';

const HtmlToReactParser = HtmlToReact.Parser;
const htmlToReactParser = new HtmlToReactParser();

const isValidNode = () => true;

const TemplateParser = (props) => {
  const { product, template, settings } = props;
  const newTemplate = addClosingTags(template);
  return htmlToReactParser.parseWithInstructions(
    newTemplate,
    isValidNode,
    processingInstructions(product, 'Detail', settings)
  );
};

export default TemplateParser;
